/* eslint-disable import/prefer-default-export */
import { ref } from "vue";
import { defineStore } from "pinia";
import useLocalStorage from "@/composables/storage/useLocalStorage.js";

const { checkLocalStorage, bindLocalStorage } = useLocalStorage();

const formObject = ref({
  identityDocumentCountry: {
    value: null,
  },
  identityDocumentType: {
    value: null,
  },
  driversLicenceFront: {
    value: null,
    error: null,
  },
  driversLicenceBack: {
    value: null,
    error: null,
  },
  passport: {
    value: null,
    error: null,
  },
  idCard: {
    hasProvided: null,
    error: null,
  },
  proofOfResidency: {
    value: null,
    error: null,
  },
});

export const useIdentityStore = defineStore({
  id: "identityStore",
  state: () => ({
    form: formObject,
  }),
  actions: {
    updateValue(field, val) {
      this.form[field].value = val;
      bindLocalStorage(this.$id, this.form);
    },
    updateState(field, error) {
      this.form[field].error = error;
      bindLocalStorage(this.$id, this.form);
    },
  },
});
